import script from "./library-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./library-table.vue?vue&type=script&setup=true&lang=ts"

import "./library-table.vue?vue&type=style&index=0&id=ddb6f38c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddb6f38c"]])

export default __exports__